<template>
  <div id="app" class="idtroc">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  components: { Header, Footer }
};
</script>

<style>
@import "./assets/stylesheet/css/idtroc.css";
@import "https://fonts.googleapis.com/css?family=Poppins:400,600,800&display=swap";
@import "./assets/idtroc_font/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue